export const ModernCheckbox = ({ id, checked, onChange, isDisabled }) => (
  <div className="foundry--checkbox">
    <input
      id={id}
      className="checkbox__input"
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={isDisabled}
    />
    <label htmlFor={id} className="checkbox__label"></label>
  </div>
)
